import { useCatalogProductsPage } from '../../../../../services/modules/catalogProducts/catalogProducts.queries';
import { PagesById, UseCatalogProductsWindowParams } from '../catalogProductsListV2.types';
import { buildPagesById, resolvePageWindow } from '../utils/productsPageWindow.utils';

export const useCatalogProductsWindow = (params: UseCatalogProductsWindowParams): PagesById => {
  const {
    catalogId,
    anchorPage,
    pageSize,
    totalItems,
    contextParams,
    sortParams,
    isSortSettled,
    groupParams,
    isGroupSettled,
    filters,
    customerIds,
    gridDataInclude,
    isOfflineMode,
    offlineSectionProductSet,
  } = params;

  const [behind, current, ahead, aheadNext] = resolvePageWindow({
    anchorPage,
    pageSize,
    totalItems,
    isEnabled: isSortSettled && isGroupSettled,
  });

  const base = {
    catalogId,
    pageSize,
    contextParams,
    sortParams,
    groupParams,
    filters,
    customerIds,
    gridDataInclude,
    isOfflineMode,
    offlineSectionProductSet,
  };

  const behindQuery = useCatalogProductsPage({
    ...base,
    page: behind.page,
    enabled: behind.isValid,
  });
  const currentQuery = useCatalogProductsPage({
    ...base,
    page: current.page,
    enabled: current.isValid,
  });
  const aheadQuery = useCatalogProductsPage({ ...base, page: ahead.page, enabled: ahead.isValid });
  const aheadNextQuery = useCatalogProductsPage({
    ...base,
    page: aheadNext.page,
    enabled: aheadNext.isValid,
  });

  return buildPagesById([
    { ...behind, query: behindQuery },
    { ...current, query: currentQuery },
    { ...ahead, query: aheadQuery },
    { ...aheadNext, query: aheadNextQuery },
  ]);
};
